import type { Messages } from '../messages';

import { accountFr } from './account';
import { channelsFr } from './channels';
import { emergencyFr } from './emergency';
import { freshnessFr } from './freshness';
import { historyFr } from './history';
import { homeFr } from './home';
import { onboardingFr } from './onboarding';
import { positionsFr } from './positions';
import { reasonFallbackFr, reasonFr } from './reason.fr';
import { sessionFr } from './session';
import { settingsFr } from './settings';

/**
 * French texts. Wording provisional until Q3 (tone): "tu" meanwhile, to match the mockups.
 * Reason texts: C2, in reason.fr.ts.
 */
export const fr: Messages = {
  app: { title: 'FXMate', navigation: 'Navigation principale' },
  tabs: { home: 'Accueil', channels: 'Canaux', positions: 'Positions', account: 'Compte' },
  home: homeFr,
  freshness: freshnessFr,
  onboarding: onboardingFr,
  positions: positionsFr,
  history: historyFr,
  session: sessionFr,
  settings: settingsFr,
  emergency: emergencyFr,
  account: accountFr,
  channels: channelsFr,
  // C2: the catalogue lives in reason.fr.ts.
  reason: reasonFr,
  reasonFallback: reasonFallbackFr,
};
